// import React from 'react';
// import ReactDOM from 'react-dom';
import {Provider} from 'react-redux'
import configureStore from './store';
import './index.css';
// import App from './App';
import * as serviceWorker from './serviceWorker';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeProvider from "./layout/provider/Theme";
// import registerServiceWorker from './registerServiceWorker';

import "./assets/scss/dashlite.scss";
import "./assets/scss/style-email.scss";

// Apply theme color IMMEDIATELY before React renders (hardcoded approach)
(function() {
    const body = document.body;
    if (!body) return;
    
    // Get saved theme color from localStorage
    const savedThemeColor = localStorage.getItem('themeColor');
    const savedFontStyle = localStorage.getItem('fontStyle');
    
    // Remove all existing theme color and font style classes
    body.className = body.className.replace(/\btheme-\w+/g, '').replace(/\bfont-\w+/g, '').trim();
    
    // Apply saved theme color immediately
    if (savedThemeColor) {
        body.classList.add(savedThemeColor);
    } else {
        // Default to cyan if nothing saved
        body.classList.add('theme-cyan');
    }
    
    // Apply saved font style immediately
    if (savedFontStyle) {
        body.classList.add(savedFontStyle);
    } else {
        // Default font style
        body.classList.add('font-montserrat');
    }
})();

// Get theme mode from localStorage or default to 'dark'
const getInitialThemeMode = () => {
    const savedMode = localStorage.getItem('themeMode');
    if (savedMode) {
        return savedMode;
    }
    // Check if lightVersion is set in localStorage (for backward compatibility)
    const lightVersion = localStorage.getItem('lightVersion');
    if (lightVersion === 'true') {
        return 'light';
    }
    return 'dark'; // Default to dark
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={configureStore()}>
        <ThemeProvider mode={getInitialThemeMode()}>
            <App/>
        </ThemeProvider>

    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//
// ReactDOM.render(
//     <Provider store={configureStore()}>
//         <FiberProvider store={configureStore()}>
//             <App />
//         </FiberProvider>, <App />
//      </Provider>,
//     document.getElementById('root')
// );
// // registerServiceWorker();
// // ReactDOM.render(<App />, document.getElementById('root'));
//
// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
